import * as React from "react"
import { TextField, type TextFieldProps } from "./TextField.tsx"

export const UrlField = (props: Omit<TextFieldProps, "type" | "onChange">) => {
  const [value, setValue] = React.useState("")

  return (
    <TextField
      type="text"
      value={value}
      onBlur={(e) => setValue(formatUrl(e.target.value))}
      onChange={(e) => setValue(e.target.value)}
      {...props}
    />
  )
}

export const formatUrl = (value: string) => {
  if (!value) return ""

  if (value.startsWith("http://")) return value.replace("http://", "https://")

  return value.startsWith("https://") ? value : `https://${value}`
}
